export var hmlInitAttr = {
  "OBJECTID": null,
  "SYSTEM": null,
  "SUB_SYSTEM": null,
  "COMPONENT": null,
  "SUB_COMPONENT": null,
  "BUILDING": null,
  "LEVEL_": null,
  "ZONE_": null,
  "POSTAL": null,
  "HML_ID": null,
  "Z_GROUND": null,
  "Z_TOP": null,
  "BULB_250W": null,
  "BULB_400W_OWS": null,
  "BULB_400W_TROIK": null,
  "BULB_400WX2": null,
  "BULB_1500W": null,
  "BULB_1000W": null,
  "CCTV": null,
  "EARTHING": null,
  "FAC_DESC": null,
  "FAC_LOC": null,
  "INSTALL_DATE": null,
  "MANUFACTURER": null,
  "SUPPLIER": null,
  "CONTRACT": null,
  "INSTALL_CONT": null,
  "MODEL_NO": null,
  "SERIAL_NO": null,
  "DWN": null,
  "FFA": null,
  "QTY": null,
  "UOM": null,
  "SRN": null,
  "WPD": null,
  "WED": null,
  "ULF": null,
  "_geometry": null,
  "LOCATION": null,
  "STAND": null,
  "HEIGHT": null
}


// WEBPACK FOOTER //
// ./src/store/modules/initialAttributes.js